export default function (axios) {
  return {
    getMenu(params) {
      return axios.get('/menu', params)
    },
  }
}
